import React from 'react';

export type OnCreate = (value: { taskName: string; projectId: number }) => void;

export interface ColumnContextValue {
  onCreate: OnCreate;
  onCancel: () => void;
  inputRef: React.Ref<HTMLInputElement>;
}

export const ColumnContext =
  React.createContext<ColumnContextValue | null>(null);
export const useColumnContext = (): ColumnContextValue => {
  const ctx = React.useContext(ColumnContext);

  if (!ctx) {
    throw new Error('Use inside ColumnContext.Provider');
  }

  return ctx;
};
